import Vue from "vue";
import Buefy from "buefy";
import Notifications from "vue-notification";
import vueAwesomeCountdown from "vue-awesome-countdown";
import firebase from "firebase/app";
import "firebase/analytics";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "@/assets/theme.scss";

Vue.config.productionTip = false;
Vue.use(Buefy);
Vue.use(Notifications);
Vue.use(vueAwesomeCountdown, "vac");

const firebaseConfig = {
  apiKey: "AIzaSyA_iqQmlkAbeiMbj1MX9zkyE-oOTslQ-CY",
  authDomain: "tryyourlucktambola-df513.firebaseapp.com",
  projectId: "tryyourlucktambola-df513",
  storageBucket: "tryyourlucktambola-df513.appspot.com",
  messagingSenderId: "355574449552",
  appId: "1:355574449552:web:f20b1c62c7515b35035f15",
  measurementId: "G-XQ8DZ99K59"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
